import { useSearchParams } from 'react-router-dom';

import Home from 'components/Home';
import Game from 'components/Game';

const Main = () => {
  const [searchParams] = useSearchParams();
  if (searchParams.get('mode') === 'daily') {
    return (
      <Game type="sedecordle" />
    );
  } else if (searchParams.get('mode') === 'free') {
    return (
      <Game type="sedecordle" />
    );
  } else {
    return (
      <Home />
    )
  }
}

export default Main;
